import React from 'react'
import { Row } from 'react-bootstrap'
import styles from './lottieSection.module.css'
import Lottie from 'react-lottie'
import Security from '../SecurityCompilance.json'
import { lottieOptions } from '../../../utils'

function SecondSection() {

  return (
    <div className={styles.secondsectionRow}>
        <p className={styles.secondSectionHeading}>Best in class </p>
        <p style={{color: "#0061D3"}} className={styles.secondSectionHeading}> Security & Compliance</p>
        <p className={styles.secondSectionContent}>Your security is our priority. We work with the most stringent banking partners, adhering to the highest standards of regulation and compliance. With advanced encryption and fraud detection, your data and transactions are always protected.
        </p>
        <div className={styles.lottiemobile}>
        <Lottie
              options={lottieOptions(Security)}
            />
            </div>
    </div>
  )
}

export default SecondSection